<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="card" >
                        <div class="card-header">
                            <h3 class="card-title">Категории</h3>
                            <div class="card-tools">
                              <button type="button" class="btn btn-sm btn-primary" @click="$refs.modal.openModal();clearForm()">
                                    <i class="fa fa-plus-square"></i>
                                    Добавить новую
                                </button>
                            </div>
                        </div>
                        <!-- /.card-header -->
                      <table class="table table-hover">
                        <thead>
                        <tr>
                          <th>id</th>
                          <th>Фото</th>
                          <th>Название</th>
                          <th>Отображение на сайте</th>
<!--                          <th>Дата создания	</th>-->
                          <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in category.data" :key="item.id">
                          <td>{{item.id}}</td>
													<td> <v-avatar>
														<v-img
																		:src="item.image"
																		alt="img"
														></v-img>
													</v-avatar></td>
                          <td>{{item.name}}</td>
													<td>
														<input type="checkbox" :checked="item.view" @click="checkboxToggle(item)">
													</td>
<!--                          <td>{{item.id}}</td>-->
                          <td style="text-align: right">
                            <a href="#" @click="getItem(item.id);$refs.modal.openModal();">
                              <i class="fa fa-edit blue"></i>
                            </a>
                            /
                            <a href="#" @click="deleteCategory(item)">
                              <i class="fa fa-trash red"></i>
                            </a>

                          </td>

                        </tr>
                        </tbody>
                      </table>
                    </div>
                </div>
            </div>
        </div>
<!--        <div v-if="!$gate.isAdmin()">-->
<!--            <not-found></not-found>-->
<!--        </div>-->
      <right-modal-widget  v-bind:id="'production-edit-modal'" v-bind:title="!editmode?'Создать запись':'Редактировать запись'" ref="modal">

      <form @submit.prevent="editmode ? updateCategory() : createCategory()">
                        <div class="modal-body">
                            <div class="form-group">
															<drop-input
																			ref="image"
																			type="image"
																			size="5"
																			crop="1280x800"
																			@file="icon(key, $event)"
															></drop-input>
														</div>
													<div class="form-group">
														<label>Показывать на сайте </label>
														<input type="checkbox" :checked="form.view"  v-model="form.view">
													</div>
                            <div class="form-group">
                                <label>Название</label>
                                <input v-model="form.name" type="text" name="name"
                                       class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                                <has-error :form="form" field="name"></has-error>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button v-show="editmode" type="submit" class="btn btn-success">Обновить</button>
                            <button v-show="!editmode" type="submit" class="btn btn-primary">Создать</button>
                        </div>
                    </form>
      </right-modal-widget>

    </section>
</template>

<script>
export default {
    data() {
        return {
            editmode: false,
					  file: false,
            category: {},
            totalDesserts: 0,
            loading: true,
            form: new Form({
                id: '',
                name: '',
							  view: '',
            }),
            search: '',
            options: {
                itemsPerPage: 50,
            },
          urls: {
            getdata: "/api/category?page=",
            update: "/api/category",
            create: "/api/category",
						show: "/api/category/",
            delete: "/api/category/",
						check: "/api/category/check",
					},
        }
    },
    watch: {
        options: {
            handler() {
                this.loadCategories()
            },
            deep: true,
        },
    },
    methods: {
			icon(key,file) {
				this.file= file ;
			},
      clearForm() {
        this.form.id = '';
        this.form.name = '';
        this.file= null;
      },
      getResults(page = 1) {
        this.$Progress.start();
        axios.get(this.urls.getdata + page).then(({ data }) => (this.category = data.data));
        this.$Progress.finish();
      },
			getItem(id) {
				var app = this;
				axios
								.get(app.urls.show + id)
								.then(function (result) {
									if (result.data.success == true) {
										var item = result.data.data;
										app.form.id = item.id;
										app.$refs.image.data(item.image);
										app.form.name = item.name;
										app.form.view = item.view;
									} else if (result.data.status == 'error') {
										this.toastError(errors.response.data.description);
									}
									app.$forceUpdate();
									app.editmode= true;
									app.$refs.rightModalWidget.openModal();
								})
								.catch(function (error) {
									//	this.toastError(errors.response.data.errors);
								});
			},
			checkboxToggle(val){
				if( val['view'] == 'checked'){
					var view=null;
				}else {
					var view='checked';
				}
				axios.post(this.urls.check, {
					id: val['id'],
					name: val['name'],
					category_id: val['category_id'],
					view: view,
					smalltext: val['smalltext'],
					text: val['text'],
					photo: val['photo'],
				})
								.then((data)=>{
									if(data.data.success){
										Toast.fire({
											icon: 'success',
											title: data.data.message
										});
										this.$Progress.finish();
										this.getResults();

									} else {
										Toast.fire({
											icon: 'error',
											title: 'Ошибка'
										});
										this.$Progress.failed();
									}
								})
			},

			updateCategory() {
          this.$Progress.start();
					console.log(11,this.form);
					var formData = new FormData();
					formData.append('file', this.file);
					axios.post( this.urls.create , formData, {
						params : {
							id: this.form.id,
							name: this.form.name,
							view: this.form.view
						},
						headers: {
							'Content-Type': 'multipart/form-data'
						}})
                .then((response) => {
                    // success
                    $('#addNew').modal('hide');
                    Toast.fire({
                        icon: 'success',
                        title: response.data.message
                    });
                    this.$Progress.finish();
                  this.editmode = false;
                  this.$refs.modal.closeModal();

                  this.getResults();
                })
                .catch(() => {
                    this.$Progress.fail();
                });

        },
        createCategory() {
					this.$Progress.start();
					var formData = new FormData();
					formData.append('file', this.file);
					axios.post( this.urls.create , formData, {
						params : {
							name: this.form.name,
							view: this.form.view
						},
						headers: {
							'Content-Type': 'multipart/form-data'
						}})
          // this.form.post(this.urls.create)
                .then((response) => {
                    $('#addNew').modal('hide');

                    Toast.fire({
                        icon: 'success',
                        title: response.data.message
                    });

                    this.$Progress.finish();
                  this.$refs.modal.closeModal();
                  this.getResults();
                })
                .catch(() => {
                    Toast.fire({
                        icon: 'error',
                        title: 'Some error occured! Please try again'
                    });
                })
        },
      deleteCategory(data){
        Swal.fire({
          title: 'Вы хотите удалить?',
          text: data.name,
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          cancelButtonText: 'Отмена',
          confirmButtonText: 'Удалить'
        }).then((result) => {

          // Send request to the server
          if (result.value) {
            this.form.delete(this.urls.delete + data.id).then(()=>{
              Swal.fire(
                  'Удалено',
                  'Успешно',
                  'success'
              );
              // Fire.$emit('AfterCreate');
              this.getResults();
            }).catch((data)=> {
              Swal.fire("Failed!", data.message, "warning");
            });
          }
        })
      },

    },
    mounted() {
      //  console.log('Component mounted.2')
			this.$Progress.start();
			this.getResults();
			this.$Progress.finish();
    },
    created() {


    }
}
</script>
<style>
.my-header-style {
    color: #6f8fb9 !important;
    font-size: 1.2em !important;
}
</style>
